module.exports = __webpack_public_path__ + "static/media/Regua_ProgramaSaudeDigital_PeriodoEleitoral.6c25ef63.png";